import algoliasearch from 'algoliasearch'
import { AlgoliaArticle, CategoryDetail } from 'types'
import { ALGOLIA_APP_ID, ALGOLIA_INDEX_SUFFIX, ALGOLIA_SEARCH_PUBLIC_KEY } from 'env'
interface AlgoliaResultProps {
  hits: []
  nbPages: number
  page: number
}
const algoliaClient = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_SEARCH_PUBLIC_KEY)
const articlesIndex = algoliaClient.initIndex(`Article_${ALGOLIA_INDEX_SUFFIX}`)

const fetch_create_from_template_articles = (categoryId: any, index: any, page = 0) => {
  return new Promise<AlgoliaResultProps>((resolve) => {
    index
      .search({
        page,
        hitsPerPage: 10,
        filters: `show_on_create_from_template:true AND category_ids:${categoryId}`,
      })
      .then((response: AlgoliaResultProps) => {
        resolve(response)
      })
  })
}

export const loadArticles = async (category: CategoryDetail) => {
  let total_hits: AlgoliaArticle[] = []
  const results = await fetch_create_from_template_articles(category.id, articlesIndex)
  total_hits = total_hits.concat(results.hits)
  total_hits = total_hits.sort((a, b) => b.copies_count - a.copies_count).slice(0, 10)
  return { name: category.name, articles: total_hits }
}
